import { NarrowPartImageCandidatesRequest } from '@/api/generatedApi';
import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { PART_IMAGE_IDENTIFICATION_QUERY_KEY } from './useGetPartImageIdentification';

export const useNarrowPartImageCandidates = (identificationId: string) => {
  const queryClient = useQueryClient();
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();
  return useMutation({
    mutationFn: async (answers: NarrowPartImageCandidatesRequest) => {
      const response = await api.tenants.narrowPartImageCandidates(tenantId, identificationId, answers);
      return response.data;
    },
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: [PART_IMAGE_IDENTIFICATION_QUERY_KEY, identificationId] }),
  });
};
